module.exports = __webpack_public_path__ + "static/img/page3.6ac6709.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/page3.jpg
// module id = TPxT
// module chunks = 0